// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3ib_M","name":"ConsentHeader_name__284kJ","birthday":"ConsentHeader_birthday__3Vcs2","skeleton":"ConsentHeader_skeleton__3Ae8Q"};